import * as React from "react";
import {Component, CSSProperties, ReactNodeArray} from "react";
import {Item} from "./Item";
import {SwitchContainer} from "../animation/SwitchContainer";
import './styles/style.scss';

import {intercept, IObservableValue, observable, observe} from "mobx";

import {ReactUtilities} from "shared/utilities/react/ReactUtilities";
import {Spring} from "shared/controls/animation/react-spring/renderprops";
export class Tabs extends React.Component<TabsProps, TabsState> {
    static defaultProps: Partial<TabsProps> = {
        disableScrollYOnAnimation:true,
        ContentHeight:'auto',
        OccupyAvailableSpace:false,
        TabToOpen:observable.box('')//disabled by default because if you use animations the scroll is shown (which looks ugly)
    };
    public static Item:typeof Item=Item;
    public different:number;
    private ListContainer: HTMLUListElement;
    private Content:HTMLElement;
    private spring: any;

    constructor(props: TabsProps) {
        super(props);
        let Items=React.Children.toArray(this.props.children) as any;
        let itemsData:ItemData[]=[];
        for(let item of Items)
            if(item!='')
                itemsData.push({
                    Item:item,
                    Container:null
                });



        let selectedItem:ItemData=null;
        if(this.props.TabToOpen.get()!='')
            selectedItem=itemsData.find(x=>x.Item.props.Id==this.props.TabToOpen);
        else {
            selectedItem = itemsData.length>0?itemsData[0]:null;
        }


        this.state = {
            Status:"resting",
            Items:itemsData,
            SelectedItem:selectedItem,
            NextItem:null
        };


        this.MonitorTabToOpen(this.props);

    }

    componentWillReceiveProps(nextProps: Readonly<TabsProps>, nextContext: any): void {
        if((nextProps as any).children!=this.props.children)
        {
            let Items=React.Children.toArray((nextProps as any).children) as any;
            let itemsData:ItemData[]=[];
            for(let item of Items)
                itemsData.push({
                    Item:item,
                    Container:null
                });

            let selectedItem:ItemData=null;
            if(nextProps.TabToOpen.get()!='')
                selectedItem=itemsData.find(x=>x.Item.props.Id==nextProps.TabToOpen);
            else {
                selectedItem = itemsData.length>0?itemsData[0]:null;
            }

            this.setState({Items:itemsData, SelectedItem:selectedItem});


        }
    }


    private OnRest() {

        if(this.state.Status=="showing") {
            this.setState({NextItem: null, Status: 'resting', SelectedItem: this.state.NextItem});
        }
    }

    public render() {

        let beforeStyles:any={width:'100%',height:'100%'};
        let afterStyles:any={width:'100%',height:'100%'};
        let additionalStyles:any={};
        let isImmediate:boolean=false;
        let contentScroll='auto';
        switch (this.state.Status) {
            case "resting":
                beforeStyles={};
                afterStyles.height='auto';
                isImmediate=true;
                break;
            case "switching":
                contentScroll='hidden';
                isImmediate=true;
                afterStyles.height=this.state.SelectedItem.Container?this.state.SelectedItem.Container.offsetHeight+1:'auto';
                break;
            case "showing":

                if(this.state.NextItem.Container!=null) {

                    if (this.Content != null && this.ListContainer != null)
                        if (this.ListContainer.offsetHeight + this.state.NextItem.Container.offsetHeight < this.Content.offsetHeight)
                            contentScroll = 'hidden';
                    afterStyles.height=this.state.NextItem.Container.offsetHeight+1;
                }else
                    afterStyles.height='auto';
                break;

        }

        let selectedItem=this.state.SelectedItem;
        if(this.state.Status=="showing")
            selectedItem=this.state.NextItem;


        return (
            <div ref={node=>this.Content=node}  className={'rnTabs'} style={this.props.styles}>
                <ul style={{margin:0,padding:0}} ref={node=>this.ListContainer=node}>
                {this.state.Items.map((x,index)=> (
                        <li key={index} className={'rnTabItem '+(selectedItem==x?'rnActive':'')} onClick={()=>this.SwitchVisibleItem(x)} >
                            <React.Fragment>
                                {x.Item.props.Icon!=null&&
                                <div  style={{display:'inline-block', marginRight:2}}>{x.Item.props.Icon}</div>}
                                {x.Item.props.Title}
                            </React.Fragment>
                        </li>
                    ))}
                </ul>

                <Spring onRest={e=>this.OnRest()} ref={node=>this.spring=node}  config={{precision:.09}}   immediate={isImmediate} from={beforeStyles} to={afterStyles} onFrame={e=>{this.OnFrame(e.height,afterStyles.height);}} >
                    {styles=>{
                        return (


                        <div  className={"rnTabContent"} style={{maxHeight:this.props.OccupyAvailableSpace==false||this.ListContainer==null?"none":`calc(100% - ${this.ListContainer.getBoundingClientRect().height}px)`, ...styles,position:'relative',borderTopLeftRadius:this.state.Items[0]==this.state.SelectedItem?0:5,overflowY:contentScroll}}>
                            {this.state.Items.map((x,index)=>{
                                let additionalStyles:any={};
                                let afterStyles:any={opacity:0};
                                if(this.state.SelectedItem==x)
                                {
                                    additionalStyles.display='block';
                                    afterStyles.opacity=1;
                                    if(this.state.Status=="showing") {
                                        additionalStyles.position = 'absolute';
                                        afterStyles.opacity=0;
                                    }
                                }
                                if(this.state.NextItem==x)
                                {
                                    additionalStyles.display='block';
                                    additionalStyles.position='absolute';
                                    additionalStyles.top=0;
                                    additionalStyles.left=0;
                                    additionalStyles.height='auto';

                                    if(this.state.Status=="showing") {
                                        afterStyles.opacity=1;
                                    }
                                }
                                return (
                                    <Spring  config={{precision:.09}}  key={index} immediate={this.state.Status!="showing"}  from={{width:'100%'}} to={afterStyles}>
                                        {styles2=>{return (
                                            <div style={{...styles2,padding:10,...x.Item.props.style, width:'100%',height:'100%',display:'none',...additionalStyles}} ref={node=>x.Container=node}>
                                                {x.Item.props.children}
                                            </div>
                                        )}}

                                    </Spring>
                                )
                            })}
                        </div>
                    )}}
                </Spring>


            </div>
        )
    }

    private SwitchVisibleItem(x: ItemData) {
        if(this.props.TabToOpen)
            this.props.TabToOpen.set(x.Item.props.Id);
        this.setState({Status:"switching",NextItem:x},()=>{this.setState({Status:"showing"})})

    }

    private MonitorTabToOpen(props: Readonly<{ children?: React.ReactNode }> & Readonly<TabsProps>) {
        if(this.props.TabToOpen!=null)
            observe(this.props.TabToOpen,(change:any)=>{
                let newValue=change.newValue;
                let item=this.state.Items.find(x=>x.Item.props.Id==newValue);
                if(!item)
                    item=this.state.Items.length>0?this.state.Items[0]:null

                this.setState({Status:"switching",NextItem:item},()=>{this.setState({Status:"showing"})});
            })
    }

    private CalculateOverflowToUse() {
        if(this.state.Status=="switching")
            return 'hidden';
        if(this.state.Status=='showing'&&this.props.disableScrollYOnAnimation)
        {
            return 'showing';
        }
        return 'auto';
    }

    private OnFrame(newHeight: any, objetiveHeight: any) {

        newHeight=Math.round(newHeight);
        objetiveHeight=Math.round(objetiveHeight);
        if(newHeight<objetiveHeight) {
            if (newHeight >= objetiveHeight - 5) {
                this.spring.stop();

            }
        }else
            if(newHeight<=objetiveHeight+5) {
                this.spring.stop();
            
            }




    }
}
/* /*<SwitchContainer className={'rnTabContent'} style={{borderTopLeftRadius:this.state.Items[0]==this.state.SelectedItem?0:5}} config={{restDisplacementThreshold:5,restSpeedThreshold:10}}>
                    {this.state.SelectedItem?this.state.SelectedItem.props.children:null}
                </SwitchContainer>*/

interface ItemData{
    Item:Item;
    Container:HTMLDivElement
}

//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TabsProps {
    styles?:CSSProperties;
    disableScrollYOnAnimation?:boolean;
    TabToOpen?:IObservableValue<string>;
    ContentHeight:string;
    ContentStyles:CSSProperties;
    OccupyAvailableSpace:boolean;

}

interface TabsState {
    Items:ItemData[];
    SelectedItem:ItemData;
    NextItem:ItemData;
    Status:'switching'|'resting'|'showing'


}

//#endregion "My Region"